module.exports = __webpack_public_path__ + "assets/marko.00f6abbc.svg";